module.exports = __webpack_public_path__ + "img/1965.36337e83.gif";